<template>
  <BaseCard class="flex w-[230px] min-h-72 flex-col items-center gap-y-2 p-4 shadow">
    <h3>
      {{ advice.title }}
    </h3>
    <img
      v-if="advice.image"
      :src="advice.image"
      :alt="advice.title"
      class="w-32 h-32 rounded-lg object-contain bg-white"
    >
    <div v-else class="w-32 h-32 rounded-lg bg-slate-200" />
    <div class="flex justify-end text-start text-sm">
      {{ advice.description }}
    </div>
    <Dialog>
      <DialogTrigger class="w-full text-right">
        <BaseButton primary density="compact">
          Voir les {{ advice.products.length }} produits
        </BaseButton>
      </DialogTrigger>
      <DialogScrollContent>
        <DialogHeader>
          <DialogTitle>
            {{ advice.title }}
          </DialogTitle>
          <DialogDescription />
        </DialogHeader>
        <div v-for="product in advice.products" :key="product.code" class="flex flex-row items-center gap-x-2">
          <img
            v-if="product.image"
            :src="product.image"
            :alt="product.name"
            class="w-16 h-16 rounded-lg object-contain bg-white"
          >
          <div v-else class="w-16 h-16 rounded-lg bg-slate-200" />
          <div>
            <div>{{ product.name }}</div>
            <div class="text-slate-500 text-sm">
              {{ product.code }}
            </div>
          </div>
        </div>
        <DialogFooter />
      </DialogScrollContent>
    </Dialog>
  </BaseCard>
</template>

<script lang="ts" setup>
import BaseCard from '@/core/components/base/BaseCard.vue';
import {SupportProgramStaticAdvice} from "@/program/interfaces/Program";
import BaseButton from "@/core/components/base/BaseButton.vue";
import {
    Dialog,
    DialogTitle,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogScrollContent,
    DialogTrigger
} from "@/core/components/ui/dialog";

defineProps<{
    advice: SupportProgramStaticAdvice;
}>();
</script>
